module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Add","empty":"No items"}}')
  delete Component.options._Ctor
}
